"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.separateParams = separateParams;
var _constants = require("../constants");
var _utils = require("../utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function formatBooleanValue(value) {
  return value === _constants.BOOLEAN_TRUE;
}
function formatDateValue(value) {
  var regExp = new RegExp(_constants.REGEXP_DATE);
  var decodedDate = decodeURIComponent(value);
  if (regExp.test(decodedDate)) {
    var _decodedDate$split = decodedDate.split("/"),
      _decodedDate$split2 = _slicedToArray(_decodedDate$split, 3),
      month = _decodedDate$split2[0],
      day = _decodedDate$split2[1],
      year = _decodedDate$split2[2];
    return "".concat(year, "-").concat(month, "-").concat(day);
  }
  return null;
}
function formatNumberRangeValue(value) {
  var regExp = new RegExp(_constants.REGEXP_NUMBER_RANGE);
  if (regExp.test(value)) {
    var _value$split = value.split("to"),
      _value$split2 = _slicedToArray(_value$split, 2),
      min = _value$split2[0],
      max = _value$split2[1];
    return "".concat(min, "~").concat(max);
  }
  regExp = new RegExp(_constants.REGEXP_NUMBER_RANGE_OPERATOR);
  if (regExp.test(value)) {
    return "gte".concat(value.replace("plus", ""));
  }
  return null;
}
function formatSortValue(value) {
  var foundSort = _constants.SORT_OPTIONS.find(function (s) {
    return s.gdp === value;
  });
  if (foundSort) {
    return foundSort.props;
  }
  return null;
}
function formatParamValue(value, config) {
  if (config.type === _constants.PARAM_TYPE_BOOLEAN) {
    return formatBooleanValue(value);
  }
  if (config.type === _constants.PARAM_TYPE_DATE_RANGE) {
    return formatDateValue(value);
  }
  if (config.type === _constants.PARAM_TYPE_NUMBER_RANGE) {
    return formatNumberRangeValue(value);
  }
  if (config.type === _constants.PARAM_TYPE_SORT) {
    return formatSortValue(value);
  }
  return value;
}
function getParam(param, config) {
  var key = param.key,
    value = param.value;
  if (config.gdp.valueInKey) {
    var _config$gdp;
    key = config.gdp.key;
    value = param.key.replace("".concat(config.gdp.key, "_"), "");
    value = ((_config$gdp = config.gdp) === null || _config$gdp === void 0 || (_config$gdp = _config$gdp.mapping) === null || _config$gdp === void 0 ? void 0 : _config$gdp[value]) || value;
  }
  return {
    key: key,
    value: formatParamValue(value, config),
    config: config
  };
}
function getRangeParamValue(min, max) {
  if (min && max) {
    return "".concat(min, "~").concat(max);
  }
  return null;
}
function separateParams(queryParams) {
  var _params;
  var params = (_params = {}, _defineProperty(_params, _constants.QUERY_PARAM_QUALIFIERS, {}), _defineProperty(_params, _constants.QUERY_PARAM_SEARCH, {}), _defineProperty(_params, _constants.QUERY_PARAM_SORT, {}), _defineProperty(_params, "others", []), _params);
  var mainParams = [];
  var supportParams = {};
  var priceMax = null;
  var priceMin = null;
  var startDateMax = null;
  var startDateMin = null;
  queryParams.forEach(function (qp) {
    if (_constants.SUPPORT_PARAMS.includes(qp.key)) {
      supportParams[qp.key] = formatBooleanValue(qp.value);
    } else {
      mainParams.push(qp);
    }
  });
  mainParams.forEach(function (qp) {
    var foundParam = _constants.PARAMS.find(function (p) {
      return p.gdp && qp.key.indexOf(p.gdp.key) === 0;
    });
    if (foundParam) {
      var param = getParam(qp, foundParam);
      if (param.value && (!param.config.gdp.support || supportParams[param.config.gdp.support])) {
        switch (param.key) {
          case "".concat(_constants.PARAM_START_DATE.gdp.key, "_maxDate"):
            startDateMax = param.value;
            break;
          case "".concat(_constants.PARAM_START_DATE.gdp.key, "_minDate"):
            startDateMin = param.value;
            break;
          case "".concat(_constants.PARAM_PRICE.gdp.key, "_max"):
            priceMax = param.value;
            break;
          case "".concat(_constants.PARAM_PRICE.gdp.key, "_min"):
            priceMin = param.value;
            break;
          case _constants.PARAM_SORT.gdp.key:
            params[foundParam.props.param] = param.value;
            break;
          default:
            {
              if (!params[foundParam.props.param][foundParam.props.key]) {
                params[foundParam.props.param][foundParam.props.key] = [];
              }
              params[foundParam.props.param][foundParam.props.key].push(param.value);
            }
            break;
        }
      }
    } else {
      var foundOtherParam = _constants.OTHER_PARAMS.find(function (p) {
        return p.gdp && qp.key.indexOf(p.gdp.key) === 0;
      });
      var _ref = (foundOtherParam === null || foundOtherParam === void 0 ? void 0 : foundOtherParam.props) || {},
        keyGdp = _ref.key;
      if (foundOtherParam) {
        params.others.push({
          key: keyGdp,
          value: qp.value
        });
      } else {
        params.others.push(qp);
      }
    }
  });
  var price = getRangeParamValue(priceMin, priceMax);
  var startDate = getRangeParamValue(startDateMin, startDateMax);
  return _objectSpread(_objectSpread({}, params), {}, {
    search: (0, _utils.sortParams)(_objectSpread(_objectSpread(_objectSpread({}, params.search), price && {
      price: price
    }), startDate && {
      startDate: startDate
    }))
  });
}